<template>
    <a-modal :visible="true" width="40vw" :footer="null" :closable="false" centered wrap-class-name="ckm-wrap" @cancel="$emit('close')">
        <div class="ckm-modal">
            <div class="ckm-head">
                <div>
                    <h3>Encerrar visita</h3>
                </div>
                <button class="ckm-x" @click="$emit('close')">
                    <span class="material-icons-outlined">close</span>
                </button>
            </div>

            <div class="ckm-body">
                <DeliveryFields :form="form" editable compact />
            </div>

            <a-alert v-if="error" type="error" show-icon :message="error" class="ckm-error" />

            <div class="ckm-foot">
                <a-button @click="$emit('close')">Cancelar</a-button>
                <a-button type="primary" :loading="saving" :disabled="!complete" @click="checkout">Encerrar visita</a-button>
            </div>
        </div>
    </a-modal>
</template>

<script>
import VisitService from "@/services/v3/visits/visit.service";
import DeliveryFields from "@/pages/seller-orders/components/delivery-fields.vue";
import { formOf, payloadOf, deliveryComplete } from "@/pages/seller-orders/delivery";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";

export default {
    name: "VisitCheckoutModal",
    components: { DeliveryFields },
    mixins: [loaderMixin],
    props: {
        visit: { type: Object, required: true },
        delivery: { type: Object, default: null },
        offered: { type: Number, default: 0 },
    },
    data() {
        return {
            form: formOf(this.delivery),
            saving: false,
            error: null,
        };
    },
    computed: {
        // Como a API: as condicoes so sao exigidas quando ha produto ofertado.
        complete() {
            return this.offered === 0 || deliveryComplete(payloadOf(this.form));
        },
    },
    methods: {
        checkout() {
            this.saving = true;
            this.error = null;
            new VisitService()
                .checkout(this.visit.id, payloadOf(this.form))
                .then(() => {
                    this.snack("Visita encerrada.");
                    this.$emit("done");
                    this.$emit("close");
                })
                .catch((error) => {
                    const data = error && error.response ? error.response.data : null;
                    let message = null;
                    if (data && Array.isArray(data.errors)) message = data.errors[0];
                    else if (data && data.errors) message = Object.values(data.errors)[0][0];
                    this.error = message || (data && data.message) || "Não foi possível encerrar a visita.";
                })
                .finally(() => {
                    this.saving = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.ckm-modal {
    background: #fff;
    display: flex;
    flex-direction: column;
}
.ckm-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 18px 20px 14px;

    h3 {
        font-size: 16px;
        font-weight: 600;
        color: #262626;
        margin: 0;
    }
}
.ckm-x {
    width: 28px;
    height: 28px;
    border: none;
    background: none;
    border-radius: 6px;
    color: #8c8c8c;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background: #f0f0f0;
        color: #262626;
    }
}
.ckm-body {
    padding: 12px 20px 16px;
    border-top: 1px solid #f0f0f0;
}
.ckm-error {
    margin: 0 20px 16px;
}
.ckm-foot {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 14px 20px;
    border-top: 1px solid #f0f0f0;
}
</style>

<style lang="scss">
.ckm-wrap {
    .ant-modal {
        min-width: 520px;
    }

    .ant-modal-content {
        padding: 0;
        border-radius: 10px;
        overflow: hidden;
    }

    .ant-modal-body {
        padding: 0;
    }
}
</style>
